import { report } from './index';
export function buryingPoint (title, axios) {
	let itemid = ''
	if (['邀请好友', '人拉人', '拉人', '邀请助力', '好友助力'].indexOf(title) >= 0) {
		itemid = '12022'
	}
	report(itemid)
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/buryingPoint/inviTation.js